import { useEffect, useMemo } from 'react';
import LocalStorageKeys from '../../../../enums/localStorage';
import usePersistedState from '../../../../hooks/usePersistedState';
import { OrdersFiltersInFrontend } from '../../../../types/apiResponse/order';
import { defaultOrderFilters } from '../constants/defaultColumnsConfig';

const useOrderFilters = () => {
  const [storedFilters, setFilters] = usePersistedState<OrdersFiltersInFrontend>(
    LocalStorageKeys.ORDER_FILTERS,
    defaultOrderFilters,
  );
  const filters = useMemo(() => {
    if (storedFilters.budgetFilterVersion === defaultOrderFilters.budgetFilterVersion) {
      return storedFilters;
    }
    // Atualiza o antigo padrão "Não" sem descartar os outros filtros salvos.
    return {
      ...defaultOrderFilters,
      ...storedFilters,
      isBudget: 'all' as const,
      budgetFilterVersion: defaultOrderFilters.budgetFilterVersion,
    };
  }, [storedFilters]);

  useEffect(() => {
    if (filters !== storedFilters) setFilters(filters);
  }, [filters, storedFilters, setFilters]);

  return [filters, setFilters] as const;
};

export default useOrderFilters;
